const initialState = {
    advertEdit: {
        open: false,
        data: {}
    },
    firstAdvertCreated: {
        open: false,
        data: {}
    }
};

const modal = (state = initialState, action) => {
    let newState;
    switch(action.type) {
        case 'OPEN_MODAL':
            newState = Object.assign({}, state);
            newState[action.modal].open = true;
            Object.assign(newState[action.modal].data, action.data);
            return newState;
        case 'CLOSE_MODAL':
            newState = Object.assign({}, state);
            newState[action.modal].open = true;
            Object.assign(newState[action.modal].data, action.data);
            return newState;
        case 'TOGGLE_MODAL':
            newState = Object.assign({}, state);
            newState[action.modal].open = !state[action.modal].open;
            Object.assign(newState[action.modal].data, action.data);
            return newState;
        case 'SET_MODAL_DATA':
            newState = Object.assign({}, state);
            Object.assign(newState[action.modal].data, action.data);
            return newState;
        default:
            return state;
    }
};

export default modal;


// WEBPACK FOOTER //
// ./src/reducers/modal.js